'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = editorStateReducer;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _handleStyleCommand = require('./handleStyleCommand');

var _editorConstants = require('../editorConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Handlers
var initialState = Immutable.Map();

/**
 * Stores a map of measurements of target IDs.
 */


// Constants
// Lib
function editorStateReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _editorConstants.EDITOR_STATE_CHANGED:
            return action.editorState;
        case _editorConstants.EDITOR_STYLE_COMMAND:
            return (0, _handleStyleCommand.handleStyleCommand)(state, action);
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/reducers/editorStateReducer.js
// module id = 1751
// module chunks = 0